import { Component } from 'react';
import GeckoRequest from 'services/gecko-request';

class Logout extends Component {
  UNSAFE_componentWillMount() {
    localStorage.clear();
    // clears fullstory cookie record
    window.FS.clearUserCookie();
    // clears intercom session
    window.Intercom('shutdown');
    window.location.href = `${process.env.REACT_APP_AUTH_URL}/logout/`;
  }

  render() {
    return null;
  }
}

export default Logout;
